import * as styles from './Button.module.css'

import React from 'react'

import classNames from 'classnames'

interface Props extends React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> {
  large?: boolean
  secondary?: boolean
  dangerous?: boolean
}

export const Button: React.FC<Props> = (props) => {
  const {
    large = false,
    secondary = false,
    dangerous = false,
    ...buttonProps
  } = props

  return (
    <button
      type="button"
      {...buttonProps}
      className={classNames(styles.button, {
        [styles.large]: large,
        [styles.secondary]: secondary,
        [styles.dangerous]: dangerous,
      })}
    />
  )
}
